export default __webpack_public_path__ + "static/media/Home-Value-Collaboration.ca372b5f.jpg";